import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from 'hooks';
import {uploadScormPageLoadingSelector, uploadScormSubmitStatusSelector, uploadScormThunk} from 'admin';

export const useUploadScorm = () => {
  const dispatch = useAppDispatch();
  const loading = useSelector(uploadScormPageLoadingSelector) as boolean;
  const submitStatus = useSelector(uploadScormSubmitStatusSelector);
  const uploadScormPackage = useCallback((payload: FormData) => dispatch(uploadScormThunk(payload)), [dispatch]);

  return {loading, submitStatus, uploadScormPackage};
};
